import { ITypedReduxAction } from '../../types/redux/actionType';
import { TCallbackPlace } from '../../types/callback';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ECallbackPopupActionTypes {
  OpenPopup = 'CALLBACK_POPUP/openPopup',
  ClosePopup = 'CALLBACK_POPUP/closePopup',
}

export type TOpenCallbackPopup = ITypedReduxAction<ECallbackPopupActionTypes.OpenPopup, TCallbackPlace>;
export type TCloseCallbackPopup = ITypedReduxAction<ECallbackPopupActionTypes.ClosePopup, void>;

export const openCallbackPopup = actionGenerator<ECallbackPopupActionTypes.OpenPopup, TCallbackPlace>(
  ECallbackPopupActionTypes.OpenPopup,
);

export const closeCallbackPopup = actionGenerator<ECallbackPopupActionTypes.ClosePopup>(
  ECallbackPopupActionTypes.ClosePopup,
);

export type TCallbackPopupActions = TOpenCallbackPopup | TCloseCallbackPopup;
